import * as React from "react";
import StyledCheckBox from "./elements/StyledCheckBox";
import { Label, Container } from "./styled/VersionPicker.styled";
export default function VersionPicker({
  handleVersionClick,
  versionChecked,
  version,
}) {
  const [checked, setChecked] = React.useState(versionChecked);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    handleVersionClick({is_selected:event.target.checked});
  };
  return (
    <Container>
      <StyledCheckBox onChange={handleChange} checked={checked} />
      <Label>{version}</Label>
    </Container>
  );
}
